import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../utils/withRouter";
import Header from "../../common_components/Header";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Footer from "../../common_components/Footer";
import { v4 as uuidv4 } from "uuid";
import { getCmsContent_action, insertUpdateCmsMenu_action, deleteCmsMenu_action } from "../../actions/cms_action/cmsAction";
import { toastError, toastSuccess } from "../../utils/constants";
import { ToastContainer } from "react-toastify";

class cmsHeaderMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuList: [],
            isLoading: false,
            cmsMenuData: [],
            cmsFooterData: [],
        };
    }

    componentDidMount() {
        if (!JSON.parse(sessionStorage.getItem("loginDataSS"))) {
            setTimeout(() => {
                this.props.navigate('/');
            }, 200);
            return;
        }
        if (sessionStorage.getItem('RoleIDSS') != 1) {
            setTimeout(() => {
                this.props.navigate('/memberDashboard');
            }, 200);
            return;
        }
        window.scrollTo(0, 0);
        this.setState({ MenuID: 1, MenuUrl: 'home', cmsMenuData: [] }, () => {
            this.getCmsContent();
        })
    }
    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            const urlHash = this.props.location.pathname;
            const cmsPrefix = '/cms/manage/';
            console.log(this.props.location, 'did');

            if (urlHash.includes('RegisteredList')) {
                window.open('#/RegisteredList', '_blank');
            } else if (urlHash.includes('companyProfile')) {
                window.open('#/companyProfile', '_blank');
            } else if (urlHash.includes('buisnessDetails')) {
                window.open('#/buisnessDetails', '_blank');
            } else if (urlHash.includes('payment')) {
                window.open('#/payment', '_blank');
            } else if (urlHash.includes('thankyou')) {
                window.open('#/thankyou', '_blank');
            } else if (urlHash.includes('enquiryForm')) {
                window.open('#/enquiryForm', '_blank');
            } else if (urlHash.includes('eventEnquiryForm')) {
                window.open('#/eventEnquiryForm', '_blank');
            } else {
                if (urlHash.startsWith(cmsPrefix)) {
                    const subPath = urlHash.substring(cmsPrefix.length);

                    const parts = subPath.split('&');
                    if (parts.length === 2) {
                        const menuURL = parts[0];
                        const MenuID = parts[1];

                        console.log("Menu URL:", menuURL);
                        console.log("Menu ID:", MenuID);

                        // Refresh the page if MenuID is "1"
                        if (MenuID === '1') {
                            window.location.reload();
                            return;
                        }

                        this.setState({ menuURL, MenuID, cmsMenuData: [] }, () => {
                            this.getCmsContent(MenuID);
                        });
                    }
                }
            }

            console.log("URL changed to:", this.props.location.pathname);
        }
    }
    async getCmsContent() {
        try {
            this.setState({ isLoading: true });

            const data = await this.props.getCmsContent_action(1, 'home');

            if (data.error !== 1) {
                const flatList = data?.data?.[1] || [];

                const menuMap = {};
                flatList.forEach(item => {
                    item.id = uuidv4();
                    item.children = [];
                    item.showSave = false;
                    menuMap[item.MenuID] = item;
                });

                const rootMenus = [];
                flatList.forEach(item => {
                    if (item.ParentID) {
                        if (menuMap[item.ParentID]) {
                            menuMap[item.ParentID].children.push(item);
                        }
                    } else {
                        rootMenus.push(item);
                    }
                });

                this.setState({
                    isLoading: false,
                    cmsMenuData: data?.data?.[1],
                    cmsFooterData: data?.data?.[2][0],
                    menuList: rootMenus,
                });
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }

    handleInputChange = (id, field, value, parent = null) => {
        // Prevent spaces in URL field
        if (field === 'Url') {
            value = value.replace(/\s/g, '');
        }

        const updateMenus = (menus) =>
            menus.map(menu => {
                if (menu.id === id) {
                    return { ...menu, [field]: value, showSave: true };
                } else if (menu.children) {
                    return {
                        ...menu,
                        children: updateMenus(menu.children)
                    };
                }
                return menu;
            });

        this.setState(prev => ({
            menuList: updateMenus(prev.menuList)
        }));
    };

    saveRowLocally = (id) => {
        const updateMenus = (menus) =>
            menus.map(menu => {
                if (menu.id === id) {
                    const title = menu.Title?.trim();
                    const url = menu.URL?.trim();

                    if (!title || !url) {
                        toastError('Both Title and URL are required.');
                        return menu; // Do not update showSave if validation fails
                    }

                    return { ...menu, showSave: false };
                } else if (menu.children) {
                    return {
                        ...menu,
                        children: updateMenus(menu.children)
                    };
                }
                return menu;
            });

        this.setState(prev => ({
            menuList: updateMenus(prev.menuList)
        }, () => {
            this.submitMenu()
        }));
    };

    addNewMenu = (parentId = null) => {
        const { menuList } = this.state;

        if (!parentId) {
            // Adding a new parent menu
            const maxSequence = menuList.reduce((max, item) => Math.max(max, item.Sequence || 0), 0);
            const newMenu = {
                id: menuList.length,  // Use the index of the menuList as the id
                MenuID: null,
                ParentID: null,
                Title: "",
                Url: "",
                Sequence: maxSequence + 1,
                isActive: true,
                isPublish: true,
                isMenuItem: true,
                children: [],
                showSave: true, id: uuidv4()
            };
            this.setState(prev => ({
                menuList: [...prev.menuList, newMenu],
            }));
        } else {
            // Adding a new child menu
            const updatedList = menuList.map(menu => {
                if (menu.id === parentId) {
                    const children = menu.children || [];
                    const maxChildSequence = children.reduce((max, item) => Math.max(max, item.Sequence || 0), 0);
                    const newChild = {
                        id: uuidv4(),
                        MenuID: null,
                        ParentID: parentId,
                        Title: "",
                        Url: "",
                        Sequence: maxChildSequence + 1,
                        isActive: true,
                        isPublish: true,
                        isMenuItem: true,
                        children: [],
                        showSave: true,
                    };
                    return {
                        ...menu,
                        children: [...children, newChild],
                    };
                }
                return menu;
            });
            this.setState({ menuList: updatedList });
        }
    };

    handleRemove = (menu, parent = null) => {
        if (menu.MenuID) {
            this.setState((prevState) => {
                const updatedList = prevState.menuList.map((item) => {
                    if (item.id === menu.id) {
                        return { ...item, isActive: false };
                    } else if (item.children) {
                        return {
                            ...item,
                            children: item.children.map((child) =>
                                child.id === menu.id ? { ...child, isActive: false } : child
                            ),
                        };
                    }
                    return item;
                });
                return { menuList: updatedList };
            });
        } else {
            this.setState((prevState) => {
                let updatedList = [...prevState.menuList];
                if (parent) {
                    updatedList = updatedList.map((item) => {
                        if (item.id === parent.id) {
                            return {
                                ...item,
                                children: item.children.filter((child) => child.id !== menu.id),
                            };
                        }
                        return item;
                    });
                } else {
                    updatedList = updatedList.filter((item) => item.id !== menu.id);
                }
                return { menuList: updatedList };
            });
        }
    };
    async deleteCmsMenu(menu, parent = null) {
        if (menu.MenuID) {
            try {
                this.setState({ isLoading: true });
                const isConfirm = window.confirm('Are you sure you want to remove this Menu?')
                if (isConfirm) {
                    const data = await this.props.deleteCmsMenu_action(menu.MenuID);

                    if (data.error !== 1) {
                        this.setState({ isLoading: false });
                        if (data.data !== "") {
                            toastSuccess(`Menu Deleted Successfully`)
                            this.getCmsContent();
                        }
                    } else {
                        this.setState({ isLoading: false });
                        toastError(data.msg);
                    }
                }
            } catch (err) {
                console.error(err);
                this.setState({ isLoading: false });
            }
        } else {
            this.setState((prevState) => {
                let updatedList = [...prevState.menuList];
                if (parent) {
                    updatedList = updatedList.map((item) => {
                        if (item.id === parent.id) {
                            return {
                                ...item,
                                children: item.children.filter((child) => child.id !== menu.id),
                            };
                        }
                        return item;
                    });
                } else {
                    updatedList = updatedList.filter((item) => item.id !== menu.id);
                }
                return { menuList: updatedList };
            });
        }
    }

    onDragEnd = result => {
        const { source, destination, type } = result;
        if (!destination) return;

        if (type === "PARENT") {
            const items = Array.from(this.state.menuList);
            const [reorderedItem] = items.splice(source.index, 1);
            items.splice(destination.index, 0, reorderedItem);

            // Recalculate sequence numbers
            const updated = items.map((item, idx) => ({ ...item, Sequence: idx + 1 }));

            this.setState({ menuList: updated });
        } else {
            const parentId = type;
            const parent = this.state.menuList.find(menu => menu.id === parentId);
            const items = Array.from(parent.children);
            const [reorderedChild] = items.splice(source.index, 1);
            items.splice(destination.index, 0, reorderedChild);

            // Recalculate child sequence
            const updatedChildren = items.map((child, idx) => ({ ...child, Sequence: idx + 1 }));

            const updatedList = this.state.menuList.map(menu =>
                menu.id === parentId ? { ...menu, children: updatedChildren } : menu
            );

            this.setState({ menuList: updatedList });
        }
    };
    renderMenuRow = (menu, index, parent = null) => {
        const isChild = !!parent;
        const isparent = menu == parent ? 1 : 0
        return (
            <Draggable key={menu.id} draggableId={menu.id.toString()} index={index}>
                {(provided) => (
                    <tr
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={{ ...provided.draggableProps.style, backgroundColor: isChild ? "#f5f5f5" : isparent == 1 ? "#eee" : "white" }}
                    >
                        {/* <td>{menu.MenuID || "-"}</td>
                        <td>{menu.ParentID || "-"}</td> */}
                        <td style={{ width: '425px' }}>
                            <input style={{ width: '100%' }}
                                type="text"
                                placeholder="Title"
                                className="form-control"
                                value={menu.Title}
                                onChange={(e) => this.handleInputChange(menu.id, "Title", e.target.value, parent)}
                            />
                        </td>
                        <td style={{ width: '430px' }}>
                            <input
                                type="text"
                                placeholder="Url"
                                className="form-control"
                                value={menu.Url}
                                onChange={(e) => this.handleInputChange(menu.id, "Url", e.target.value, parent)}
                            />
                        </td>{console.log(parent, 'parent')}
                        <td className="text-center" style={{ width: '100px' }}>
                            {`${parent?.Sequence ? parent.Sequence + '.' : ''}${menu.Sequence}`}
                        </td>
                        {/* <td className="text-center" style={{ width: '100px' }}>
                            <div class="custom-control custom-checkbox"
                                onClick={() => this.handleInputChange(menu.id, "isActive", !menu.isActive, parent)} >
                                <input type="checkbox" class="custom-control-input" checked={menu.isActive} value={menu.isActive} />
                                <label class="custom-control-label" ></label>
                            </div>
                        </td> */}
                        <td className="text-center" style={{ width: '100px' }}>
                            <div className="custom-control custom-checkbox d-flex justify-content-center pt-2">
                                <input type="checkbox"
                                    className="custom-control-input"
                                    id={`customCheck${menu.id}`}
                                    checked={menu.isActive}
                                    value={menu.isActive}
                                    onClick={() => this.handleInputChange(menu.id, "isActive", !menu.isActive, parent)}
                                />
                                <label className="custom-control-label" htmlFor={`customCheck${menu.id}`}></label>
                            </div>
                        </td>

                        {/* <td className="text-center" style={{ width: '100px' }}>
                            <div class="custom-control custom-checkbox"
                                onClick={() => this.handleInputChange(menu.id, "isPublish", !menu.isPublish, parent)} >
                                <input type="checkbox" class="custom-control-input" checked={menu.isPublish} value={menu.isPublish} />
                                <label class="custom-control-label" ></label>
                            </div>

                        </td>
                        <td className="text-center" style={{ width: '100px' }}>
                            <div class="custom-control custom-checkbox"
                                onClick={() => this.handleInputChange(menu.id, "isMenuItem", !menu.isMenuItem, parent)} >
                                <input type="checkbox" class="custom-control-input" checked={menu.isMenuItem} value={menu.isMenuItem} />
                                <label class="custom-control-label" ></label>
                            </div>
                        </td> */}

                        <td className="text-center" style={{ width: '100px' }}>
                            <div className="custom-control custom-checkbox d-flex justify-content-center pt-2">
                                <input type="checkbox"
                                    className="custom-control-input"
                                    id={`publishCheckbox${menu.id}`}
                                    checked={menu.isPublish}
                                    value={menu.isPublish}
                                    onClick={() => this.handleInputChange(menu.id, "isPublish", !menu.isPublish, parent)}
                                />
                                <label className="custom-control-label" htmlFor={`publishCheckbox${menu.id}`}></label>
                            </div>
                        </td>

                        <td className="text-center" style={{ width: '100px' }}>
                            <div className="custom-control custom-checkbox d-flex justify-content-center pt-2">
                                <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id={`menuItemCheckbox${menu.id}`}
                                    checked={menu.isMenuItem}
                                    value={menu.isMenuItem}
                                    onClick={() => this.handleInputChange(menu.id, "isMenuItem", !menu.isMenuItem, parent)}
                                />
                                <label className="custom-control-label" htmlFor={`menuItemCheckbox${menu.id}`}></label>
                            </div>
                        </td>

                        <td className="text-right" style={{ width: '100px' }}>
                            {!isChild && (
                                <button className="btn btn-sm btn-outline-success mx-2" onClick={() => this.addNewMenu(menu.id)}>+</button>
                            )}
                            <button className="btn btn-sm btn-outline-danger" onClick={() => this.deleteCmsMenu(menu, parent)}><i class="fa fa-trash-o"></i></button>
                            {/* {menu.showSave && (
                                <button className="btn btn-sm btn-outline-primary" onClick={() => this.saveRowLocally(menu.id)}>Save</button>
                            )} */}
                        </td>
                    </tr>
                )}
            </Draggable>
        );
    };

    async submitMenu() {
        try {
            const { menuList } = this.state;
            this.setState({ isLoading: true });

            const flatMenuList = [];

            for (const parent of menuList) {
                const { children, ...parentData } = parent;

                const hasInvalidParent = !parentData.Title?.trim() || !parentData.Url?.trim();
                if (hasInvalidParent) {
                    toastError('Kindly Enter Title and Url in all Menu');
                    this.setState({ isLoading: false });
                    return;
                }

                const parentMenuID = parentData.MenuID || null;

                flatMenuList.push({
                    MenuID: parentMenuID,
                    ParentID: null,
                    Title: parentData.Title,
                    Url: parentData.Url,
                    Sequence: parentData.Sequence,
                    isActive: parentData.isActive,
                    isPublish: parentData.isPublish,
                    isMenuItem: parentData.isMenuItem
                });

                if (Array.isArray(children)) {
                    for (const child of children) {
                        const hasInvalidChild = !child.Title?.trim() || !child.Url?.trim();
                        if (hasInvalidChild) {
                            toastError('Kindly Enter Title and Url in all Menu');
                            this.setState({ isLoading: false });
                            return;
                        }

                        flatMenuList.push({
                            MenuID: child.MenuID || null,
                            ParentID: parentMenuID,
                            Title: child.Title,
                            Url: child.Url,
                            Sequence: child.Sequence,
                            isActive: child.isActive,
                            isPublish: child.isPublish,
                            isMenuItem: child.isMenuItem
                        });
                    }
                }
            }

            const data = await this.props.insertUpdateCmsMenu_action(flatMenuList);

            this.setState({ isLoading: false });

            if (data.error !== 1) {
                toastSuccess('Menu Added Successfully');
                this.getCmsContent();
            } else {
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }

    render() {
        const { menuList, cmsMenuData, cmsFooterData } = this.state;

        return (<>
            <ToastContainer />
            <Header headerNavs={cmsMenuData} />
            <section class="registration_form">
                <div class="container">
                    <div class="row ">
                        <section className="table_section mt-0">
                            <div className="container">
                                <div className="row">
                                    <div className="col-12 col-sm-12 col-lg-12">
                                        <div className="card shadow-none border mb-2" >
                                            <div className="card-header py-2">
                                                <h6 className='pt-2' style={{ float: 'left' }}>CMS Menu Settings</h6>
                                                <a style={{ float: 'right' }}
                                                    href="javascript:void(0);"
                                                    title="Add Role"
                                                    onClick={() => this.addNewMenu()}
                                                    className="load_document_icon  p-1 px-2 nav-add-btn mx-1"
                                                    data-toggle="modal"
                                                    data-target="#add_comment_modal"
                                                >
                                                    Add Menu
                                                </a>
                                            </div>
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: '425px' }}>Title</th>
                                                        <th style={{ width: '425px' }}>URL</th>
                                                        <th className="text-center" style={{ width: '100px' }}>Sequence</th>
                                                        <th className="text-center" style={{ width: '100px' }}>Active</th>
                                                        <th className="text-center" style={{ width: '100px' }}>Publish</th>
                                                        <th className="text-center" style={{ width: '100px' }}>Menu Item</th>
                                                        <th className="text-right" style={{ width: '100px' }}>Actions</th>
                                                    </tr>
                                                </thead>
                                                <DragDropContext onDragEnd={this.onDragEnd}>
                                                    <Droppable droppableId="menuList" type="PARENT">
                                                        {(provided) => (
                                                            <tbody ref={provided.innerRef} {...provided.droppableProps}>
                                                                {menuList.length > 0 ? menuList?.sort((a, b) => a.Sequence - b.Sequence)?.map((menu, index) => (
                                                                    <React.Fragment key={menu.id}>
                                                                        {this.renderMenuRow(menu, index)}
                                                                        {menu.children && menu.children.length > 0 && (
                                                                            <Droppable droppableId={menu.id} type={menu.id}>
                                                                                {(providedChild) => (
                                                                                    <tr>
                                                                                        <td className="pr-0" colSpan="7" style={{ paddingLeft: '10px', background: '#eee', }}>
                                                                                            <table className="table mb-0">
                                                                                                <tbody ref={providedChild.innerRef} {...providedChild.droppableProps}>
                                                                                                    {menu.children?.sort((a, b) => a.Sequence - b.Sequence)?.map((child, childIndex) =>
                                                                                                        this.renderMenuRow(child, childIndex, menu)
                                                                                                    )}
                                                                                                    {providedChild.placeholder}
                                                                                                </tbody>
                                                                                            </table>
                                                                                        </td>
                                                                                    </tr>
                                                                                )}
                                                                            </Droppable>
                                                                        )}
                                                                    </React.Fragment>
                                                                )) : <>
                                                                    <tr>
                                                                        <td className="text-center" colSpan={8}>No Menu Available</td>
                                                                    </tr>
                                                                </>}
                                                                {provided.placeholder}
                                                            </tbody>
                                                        )}
                                                    </Droppable>
                                                </DragDropContext>
                                            </table>
                                            <div className="m-2">
                                                {menuList.length > 0 && <>
                                                    <button className="load_document_icon  p-1 px-2 edit-submit-btn rounded-1" style={{ padding: '5px 15px !important' }}
                                                        data-toggle="modal"
                                                        data-target="#add_comment_modal" onClick={() => this.submitMenu()}>Submit Menu</button>
                                                </>}
                                                <button className="load_document_icon  p-1 px-2 add-sec-btn mx-2 rounded-1" style={{ padding: '5px 15px !important' }}
                                                    data-toggle="modal"
                                                    data-target="#add_comment_modal" onClick={() => this.addNewMenu()}>Add Menu</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </section>
            <Footer footerData={cmsFooterData} />
        </>
        );
    }
}

export default withRouter(connect(null, { getCmsContent_action, insertUpdateCmsMenu_action, deleteCmsMenu_action })(cmsHeaderMaster));